import { Trophy } from '@heathmont/moon-assets';
import { EmptyState } from '@heathmont/moon-components';
import { Text } from '@heathmont/moon-core';
import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';
import useTranslation from '~/client/hooks/i18n/useTranslation';
import useThemeContext from '~/client/hooks/theme/useThemeContext';
import media from '~/client/shared/media';
import Stack from '~/client/shared/Stack';
import capitalize from '~/shared/utils/string/capitalize';
import getTournamentColor from '../../../shared/TournamentCard/utils/getTournamentColor';

const Icon = styled(Trophy)`
  border-radius: 50%;
  background: ${({ theme }) => theme.color.goku[100]};
`;

const Container = styled(Stack)`
  width: 100%;
  max-width: ${rem(1172)};
  ${media.desktopMedium} {
    width: ${rem(1172)};
  }
`;

type Props = {
  status?: TournamentStatus;
  onlyMine?: boolean;
};

const getNoTournamentText = (activityType?: TournamentStatus) => {
  switch (activityType) {
    case 'current':
      return 'tournaments.no-active-tournaments';
    case 'future':
      return 'tournaments.no-future-tournaments';
    case 'past':
      return 'tournaments.no-past-tournaments';
    default:
      return 'general.empty_state_my_participations';
  }
};

const TournamentEmptyState: FC<Props> = ({ status = 'current', onlyMine }) => {
  const title = useTranslation(
    status
      ? `gameleaderboard.${status}`
      : 'general.menu_item.my_participations',
  );
  const { theme } = useThemeContext();

  return (
    <Container>
      <Text size={18} as="span" color="trunks.100">
        {capitalize(title.toLowerCase())}
      </Text>
      <EmptyState
        icon={
          <Icon fontSize="5rem" color={getTournamentColor({ status, theme })} />
        }
        title={useTranslation(
          onlyMine
            ? 'general.empty_state_my_participations'
            : getNoTournamentText(status),
        )}
      />
    </Container>
  );
};

export default TournamentEmptyState;
